import { GET_COMMUNICATION_LIST_SUCCESS } from "../action-types/communication";
import CommunicationService from "../services/communication";

// *******************************
//  GET COMMUNICATION LIST
// *******************************

export const getCommunicationList = (registrationRef) => {
    return dispatch => {
        //dispatch(setAppLoading(true));

        CommunicationService.getCommunicationList(registrationRef, true)
        .then((response) => {
            //dispatch(setAppLoading(false));
            dispatch(getCommunicationListSuccess(response));
        })
        .catch(error => {
            //dispatch(setAppLoading(false));
            //dispatch(appError("general.popup-messages.admin.get-group-list-error"));
        });
    };
}

export const getCommunicationListSuccess = (communications) => {
    return  {
        type: GET_COMMUNICATION_LIST_SUCCESS,
        communications: communications
    };
}